import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import styled, { css } from 'styled-components';

export const buttonHover = css`
  &:hover {
    cursor: pointer;
  }
`;

export const InsightsToggle = styled(Select)`
  font-size: 12px;
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-radius: 5px;
  &:hover {
    color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.onPrimary};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
    border: 1px solid
      ${(props) => props.theme.atlas.semantic.color.action.primary.default};
    opacity: 100%;
  }
  &:before {
    content: none;
  }
  margin: ${(props) => `${props.theme.spacing(1)}`};
  & .MuiSelect-select {
    padding-right: 0px;
  }

  & .MuiSelect-select:focus {
    background-color: inherit;
    border-radius: 5px;
    padding-right: 0px;
  }

  & .MuiSelect-select:hover {
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
    color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.onPrimary};
  }

  & .MuiInputBase-input {
    padding: 8px 0 8px;
  }
  min-width: 154px;
  text-align: center;
`;

export const InsightsMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-size: 14px;
    &:hover {
      background-color: ${(props) =>
        props.theme.atlas.semantic.color.action.secondary.hoverFill};
      transition: none;
    }
    padding: ${(props) => `${props.theme.spacing(1)}`};
    min-width: 150px;
    text-align: center;
    transition: none;
  }
`;

export const InsightsTitle = styled('span')`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
`;

export const InsightsRow = styled.div<{ multipleCharts?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
  ${(props) => props.multipleCharts && 'gap: 20px;'}
  ${(props) => props.multipleCharts && 'flex-direction: row;'}

@media screen and (min-width: 0px) and (max-width: 900px) {
    ${(props) => props.multipleCharts && 'flex-direction: column;'}
    ${(props) => props.multipleCharts && 'gap: 40px;'}
  }
`;

export const ChartContainer = styled(Paper)<{ $screenWidth: 'full' | 'half' }>`
  width: ${(props) =>
    props.$screenWidth === 'half' ? '50%' : '100%'} !important;
  height: 500px !important;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    ${(props) => props.$screenWidth === 'half' && ' width: 100%!important;'}
  }
`;

export const Expand = styled(ExpandMoreIcon)`
  ${buttonHover}
`;

export const Close = styled(ExpandLessIcon)`
  ${buttonHover}
`;

export const TotalNumberOfReports = styled(MenuItem)`
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  border: 1px solid ${(props) => props.theme.atlas.semantic.color.type.default};
  box-shadow:
    0px 1px 5px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  margin: 20px;
  align-self: center;
`;

export const InsightsHeading = styled.div`
  margin: 25px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  font-size: 20px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
`;

export const InsightsToggleContainer = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`;

export const InsightsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-x: auto;
  margin: 8px;
  height: 100%;
  overflow: scroll;
`;
